import React, { useContext } from 'react'
import { Grid, GridCell, Spacer, Text, View } from 'oio-react'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeMetadataBlock = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <View float="left" width="100%">
         <View
            display="flex"
            float="left"
            width="100%"
            borderRadius="5px">
            <View float="left" width="100%">
               <Text
                  size="2"
                  color="#666"
                  weight="normal">
                  <Grid columns="1" spacing="20px">
                     {initiative.numViews > 0 && (
                        <GridCell>
                           <View
                              float="left"
                              width="100%"
                              borderBottom="1px solid rgba(0,0,0,0.1)"
                              paddingBottom="20px">
                              <Text
                                 size="0.7"
                                 weight="medium"
                                 transform="uppercase"
                                 color="#aaa">
                                 Views
                              </Text>
                              <Spacer size="1" />
                              <Text size="6" color="#666" weight="medium2">
                                 {initiative.numViews}
                              </Text>
                           </View>
                        </GridCell>
                     )}
                     {initiative.thread.numEntries > 0 && (
                        <GridCell>
                           <View
                              float="left"
                              width="100%"
                              borderBottom="1px solid rgba(0,0,0,0.1)"
                              paddingBottom="20px">
                              <View>
                                 <Text
                                    size="0.7"
                                    weight="medium"
                                    transform="uppercase"
                                    color="#aaa">
                                    Comments
                                 </Text>
                                 <Spacer size="1" />
                                 <Text size="6" color="#666" weight="medium2">
                                    {initiative.thread.numEntries}
                                 </Text>
                              </View>
                           </View>
                        </GridCell>
                     )}
                     <GridCell>
                        <View float="left" width="100%">
                           <View>
                              <Text
                                 size="0.7"
                                 weight="medium"
                                 transform="uppercase"
                                 color="#aaa">
                                 Last Updated
                              </Text>
                              <Spacer size="1" />
                              <Text size="1.5" color="#777" weight="medium">
                                 {initiative.dateLastUpdated}
                              </Text>
                           </View>
                        </View>
                     </GridCell>
                  </Grid>
               </Text>
            </View>
         </View>
      </View>
   )
}

export default InitiativeMetadataBlock
